let activeOptions = {};

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function getStyleProperty(element, property) {
  return window.getComputedStyle(element).getPropertyValue(property);
}

/*
 * Shopify Common JS
 *
 */

if (typeof window.Shopify === "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent(`on${eventName}`, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  const method = options.method || "post";
  const params = options.parameters || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options.hideElement || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry() {
    const value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince() {
    const value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler(e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    const raw = opt.getAttribute("data-provinces");
    const provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (let i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions(selector, values) {
    for (let i = 0, count = values.length; i < values.length; i++) {
      const opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class QuantityCounter extends HTMLElement {
  constructor() {
    super();
    this.changeEvent = new Event("change", { bubbles: true });
  }

  connectedCallback() {
    this.counterEl = this.querySelector(".js-counter-quantity");
    this.increaseBtn = this.querySelector(".js-counter-increase");
    this.decreaseBtn = this.querySelector(".js-counter-decrease");

    this.min = parseInt(this.counterEl.min) || 1;
    this.max = parseInt(this.counterEl.max) || 999;

    this.increaseBtn.addEventListener("click", this.onIncrease.bind(this));
    this.decreaseBtn.addEventListener("click", this.onDecrease.bind(this));
  }

  onIncrease() {
    const currentValue = parseInt(this.counterEl.value);
    if (currentValue < this.max) {
      this.updateValue(currentValue + 1);
    }
  }

  onDecrease() {
    const currentValue = parseInt(this.counterEl.value);
    if (this.dataset.cart) this.min = 0;
    if (currentValue > this.min) {
      this.updateValue(currentValue - 1);
    }
  }

  updateValue(value) {
    this.counterEl.value = value;

    this.counterEl.dispatchEvent(this.changeEvent);
  }
}

// Define the custom element
window.customElements.define("quantity-counter", QuantityCounter);

// without under functions main-password doesn't work

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

function toggleTabindex(elements) {
  elements.forEach((el) => {
    const tabindex = el.getAttribute("tabindex");
    el.setAttribute("tabindex", tabindex === "0" ? "-1" : "0");
  });
}

function setTabindex(elements, tabindex) {
  elements.forEach((el) => {
    el.setAttribute("tabindex", tabindex);
  });
}

// Helper function to add multiple event listeners with the same handler
function addEventListeners(element, events, handler) {
  events.forEach((event) => element.addEventListener(event, handler));
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  const elements = getFocusableElements(container);
  const first = elements[0];
  const last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      this.prefetchSameColor();

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          this.setAttribute("data-rec-ready", "");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          this.querySelector("rec-product-grid")?.start();

          if (html.querySelector(".grid__item") || html.querySelector(".rec-grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }

          if (window.VariantSwatches && window.VariantSwatches.scanCards) {
            window.VariantSwatches.scanCards();
          }

          // More You Love 由 rec-product-grid.reveal() 再扫曝光。
          // 这里立刻扫会打到尚未 hidden 的整页卡。无 rec-product-grid 的推荐区仍要扫。
          if (!this.querySelector("rec-product-grid")) {
            window.SpTracker?.scanProductImpressions?.(this);
          }
        })
        .catch((e) => {
          console.error(e);
          this.setAttribute("data-rec-ready", "");
          this.querySelector("rec-product-grid")?.start();
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }

  prefetchSameColor() {
    if (this._sameColorPrefetch) return this._sameColorPrefetch;
    const color = this.querySelector("rec-product-grid")?.dataset.color;
    if (!color) {
      this._sameColorPrefetch = Promise.resolve([]);
      return this._sameColorPrefetch;
    }
    this._sameColorAbort = new AbortController();
    this._sameColorPrefetch = this.fetchSameColorByQueries(color, this._sameColorAbort.signal).catch(
      (e) => {
        if (e?.name === "AbortError") return [];
        console.error(e);
        return [];
      }
    );
    return this._sameColorPrefetch;
  }

  async fetchSameColorByQueries(color, signal) {
    const root = window.Shopify?.routes?.root || "/";
    const queries = [`in ${color}`, color];
    const merged = [];
    const seen = new Set();

    for (const q of queries) {
      if (signal?.aborted) break;
      try {
        const url = `${root}search?q=${encodeURIComponent(q)}&type=product&view=rec-same-color`;
        const response = await fetch(url, {
          credentials: "same-origin",
          headers: { Accept: "text/html" },
          signal,
        });
        if (!response.ok) continue;
        const text = await response.text();
        const cards = this.parseSameColorCards(text);
        for (const card of cards) {
          if (!card.handle || seen.has(card.handle)) continue;
          seen.add(card.handle);
          merged.push(card);
        }
        // Enough unique cards to cover a 10-slot same-color row after dedupe.
        if (merged.length >= 16) break;
      } catch (e) {
        if (e?.name === "AbortError") throw e;
      }
    }
    return merged;
  }

  parseSameColorCards(text) {
    if (!text || !text.trim()) return [];
    const doc = document.createElement("div");
    doc.innerHTML = text;
    return Array.from(doc.querySelectorAll(".rec-grid__item")).map((el) => ({
      handle: el.dataset.handle || "",
      styleKey: (el.dataset.styleKey || "").trim().toLowerCase(),
      html: el.outerHTML,
    })).filter((item) => item.handle && item.html);
  }
}

if (!customElements.get("product-recommendations")) {
  customElements.define("product-recommendations", ProductRecommendations);
}

class RecProductGrid extends HTMLElement {
  connectedCallback() {
    const host = this.closest("product-recommendations");
    if (host && host.dataset.url && !host.hasAttribute("data-rec-ready")) return;
    this.start();
  }

  async start() {
    if (this.hasAttribute("data-rec-started")) return;
    this.setAttribute("data-rec-started", "");

    this.actions = this.querySelector("[data-rec-actions]");
    this.btn = this.querySelector("[data-rec-more]");
    this.visible = 0;
    this.excludeHandle = (this.dataset.excludeHandle || "").trim();

    this.btn?.addEventListener("click", () => this.reveal(this.pageSize()));
    this.mq = window.matchMedia("(min-width: 900px)");
    this.onBreakpoint = () => {
      const min = this.pageSize();
      if (this.visible < min) this.reveal(min - this.visible);
    };
    if (this.mq.addEventListener) {
      this.mq.addEventListener("change", this.onBreakpoint);
    } else {
      this.mq.addListener(this.onBreakpoint);
    }

    this.stripExcluded();
    // 等 fillSameColor 时整页卡都还在 DOM；先藏起来，避免扫到 View more 后面的卡。
    this.hideRecItems();
    await this.fillSameColor();
    if (this.aborted) return;

    this.items = Array.from(this.querySelectorAll("[data-rec-products] .rec-grid__item"));
    if (!this.items.length) {
      this.closest(".wt-featured-collection")?.setAttribute("hidden", "");
      return;
    }

    this.hideRecItems();
    this.classList.add("is-ready", "is-filled");
    this.reveal(this.pageSize());

    if (window.VariantSwatches && window.VariantSwatches.scanCards) {
      window.VariantSwatches.scanCards();
    }
  }

  hideRecItems() {
    this.querySelectorAll("[data-rec-products] .rec-grid__item").forEach((el) => {
      el.hidden = true;
    });
  }

  stripExcluded() {
    if (!this.excludeHandle) return;
    this.querySelectorAll("[data-rec-products] .rec-grid__item").forEach((el) => {
      if (el.dataset.handle === this.excludeHandle) el.remove();
    });
  }

  disconnectedCallback() {
    this.aborted = true;
    if (!this.mq || !this.onBreakpoint) return;
    if (this.mq.removeEventListener) {
      this.mq.removeEventListener("change", this.onBreakpoint);
    } else {
      this.mq.removeListener(this.onBreakpoint);
    }
  }

  async fillSameColor() {
    const target = Number(this.dataset.sameTarget || 10);
    const grid = this.querySelector("[data-rec-products]") || this.querySelector(".rec-grid");
    const host = this.closest("product-recommendations");
    if (!grid) return;

    const sameItems = Array.from(grid.querySelectorAll('[data-rec-phase="same"]'));
    if (sameItems.length >= target) {
      host?._sameColorAbort?.abort();
      return;
    }

    try {
      const cards = await (host?.prefetchSameColor?.() || this.fetchSameColorCards());
      if (this.aborted) return;

      const color = (this.dataset.color || "").trim().toLowerCase();
      const titleNeedle = color ? ` in ${color}` : "";
      const handleNeedle = color ? `-in-${color.replace(/\s+/g, "-")}` : "";
      const existing = new Set(
        Array.from(grid.querySelectorAll("[data-handle]")).map((el) => el.dataset.handle)
      );
      const existingBases = new Set(
        Array.from(grid.querySelectorAll("[data-style-key]"))
          .map((el) => (el.dataset.styleKey || "").trim().toLowerCase())
          .filter(Boolean)
      );
      if (this.excludeHandle) existing.add(this.excludeHandle);

      const need = target - sameItems.length;
      const firstOther = grid.querySelector('[data-rec-phase="other"]');
      let added = 0;

      for (const card of cards || []) {
        if (added >= need) break;
        const handle = card.handle;
        if (!handle || existing.has(handle)) continue;

        const title = this.titleFromCardHtml(card.html).toLowerCase();
        const handleL = handle.toLowerCase();
        if (!this.isSameColorMatch(title, handleL, titleNeedle, handleNeedle)) continue;

        const styleKey = (card.styleKey || this.styleKeyFromTitle(title)).trim().toLowerCase();
        if (styleKey && existingBases.has(styleKey)) continue;

        const el = this.wrapRecCard(handle, card.html);
        if (!el) continue;

        existing.add(handle);
        if (styleKey) existingBases.add(styleKey);
        el.hidden = true;
        grid.insertBefore(el, firstOther);
        added += 1;
      }
    } catch (e) {
      if (e?.name !== "AbortError") console.error(e);
    }
  }

  titleFromCardHtml(html) {
    try {
      const wrap = document.createElement("div");
      wrap.innerHTML = html;
      return wrap.querySelector(".card__title")?.textContent?.trim() || "";
    } catch (e) {
      return "";
    }
  }

  isSameColorMatch(title, handle, titleNeedle, handleNeedle) {
    if (!titleNeedle && !handleNeedle) return true;
    const titleL = String(title || "").trim().toLowerCase();
    const handleL = String(handle || "").trim().toLowerCase();
    if (titleNeedle && titleL.endsWith(titleNeedle)) return true;
    if (handleNeedle && handleL.endsWith(handleNeedle)) return true;
    return false;
  }

  styleKeyFromTitle(title) {
    const raw = String(title || "").trim().toLowerCase();
    if (!raw) return "";
    const parts = raw.split(" in ");
    if (parts.length < 2) return raw;
    return parts.slice(0, -1).join(" in ").trim();
  }

  async fetchSameColorCards() {
    const color = (this.dataset.color || "").trim();
    if (!color) return [];
    try {
      const host = this.closest("product-recommendations");
      if (host?.fetchSameColorByQueries) {
        return await host.fetchSameColorByQueries(color);
      }
      const root = window.Shopify?.routes?.root || "/";
      const url = `${root}search?q=${encodeURIComponent(`in ${color}`)}&type=product&view=rec-same-color`;
      const response = await fetch(url, {
        credentials: "same-origin",
        headers: { Accept: "text/html" },
      });
      if (!response.ok) return [];
      const text = await response.text();
      const doc = document.createElement("div");
      doc.innerHTML = text;
      return Array.from(doc.querySelectorAll(".rec-grid__item")).map((el) => ({
        handle: el.dataset.handle || "",
        styleKey: (el.dataset.styleKey || "").trim().toLowerCase(),
        html: el.outerHTML,
      })).filter((item) => item.handle && item.html);
    } catch (e) {
      return [];
    }
  }

  wrapRecCard(handle, html) {
    const wrap = document.createElement("div");
    wrap.innerHTML = html.trim();
    const el = wrap.querySelector(".rec-grid__item") || wrap.firstElementChild;
    if (!el) return null;
    el.dataset.recPhase = "same";
    el.dataset.handle = handle;
    if (!el.querySelector(".card__container, .card")) return null;
    return el;
  }

  pageSize() {
    return window.matchMedia("(min-width: 900px)").matches
      ? Number(this.dataset.desktopPage || 10)
      : Number(this.dataset.mobilePage || 10);
  }

  reveal(count) {
    const next = this.visible + count;
    this.items.forEach((el, i) => {
      el.hidden = i >= next;
    });
    this.visible = Math.min(next, this.items.length);
    if (this.actions) this.actions.hidden = this.visible >= this.items.length;
    window.SpTracker?.scanProductImpressions?.(this);
  }
}

if (!customElements.get("rec-product-grid")) {
  customElements.define("rec-product-grid", RecProductGrid);
}

// Product card hover video (lazy m3u8-first, one at a time)
(function () {
  const HOVER_VIDEO_SELECTOR = ".card__video--hover[data-card-hover-video]";
  const HLS_CDN = "https://cdn.jsdelivr.net/npm/hls.js@1.5.7/dist/hls.min.js";
  let activeVideo = null;
  let loadToken = 0;
  let hlsLoader = null;
  const hlsByVideo = new WeakMap();

  function getCardHoverVideo(eventTarget) {
    const card = eventTarget?.closest?.(".card");
    if (!card) return null;
    return card.querySelector(HOVER_VIDEO_SELECTOR);
  }

  function isLeavingOrEnteringCard(card, relatedTarget) {
    return !relatedTarget || !card.contains(relatedTarget);
  }

  function canPlayNativeHls() {
    const probe = document.createElement("video");
    return probe.canPlayType("application/vnd.apple.mpegurl") !== "";
  }

  function loadHlsJs() {
    if (window.Hls) return Promise.resolve(window.Hls);
    if (hlsLoader) return hlsLoader;
    hlsLoader = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = HLS_CDN;
      script.async = true;
      script.onload = () =>
        window.Hls ? resolve(window.Hls) : reject(new Error("Hls missing"));
      script.onerror = () => reject(new Error("Hls load failed"));
      document.head.appendChild(script);
    });
    return hlsLoader;
  }

  function destroyHls(video) {
    const hls = hlsByVideo.get(video);
    if (!hls) return;
    try {
      hls.destroy();
    } catch (e) {}
    hlsByVideo.delete(video);
  }

  function unloadVideo(video) {
    if (!video) return;
    destroyHls(video);
    video.pause();
    video.dataset.playing = "false";
    video.dataset.loaded = "false";
    video.removeAttribute("src");
    video.querySelectorAll("source").forEach((source) => source.remove());
    try {
      video.load();
    } catch (e) {}
    if (activeVideo === video) activeVideo = null;
  }

  function playMedia(video, token) {
    if (token !== loadToken || activeVideo !== video) return;
    video.muted = true;
    video.dataset.playing = "true";
    const playPromise = video.play();
    if (playPromise?.catch) {
      playPromise.catch(() => {
        if (token !== loadToken || activeVideo !== video) return;
        video.dataset.playing = "false";
      });
    }
  }

  function attachMp4(video, token) {
    const mp4 = video.dataset.mp4Src || video.dataset.src;
    if (!mp4) return;
    destroyHls(video);
    video.querySelectorAll("source").forEach((source) => source.remove());
    video.removeAttribute("src");
    const source = document.createElement("source");
    source.src = mp4;
    source.type = "video/mp4";
    video.appendChild(source);
    video.dataset.loaded = "true";
    try {
      video.load();
    } catch (e) {}
    playMedia(video, token);
  }

  function attachNativeHls(video, hlsSrc, token) {
    video.src = hlsSrc;
    video.dataset.loaded = "true";
    const onError = () => {
      video.removeEventListener("error", onError);
      if (token !== loadToken || activeVideo !== video) return;
      attachMp4(video, token);
    };
    video.addEventListener("error", onError, { once: true });
    try {
      video.load();
    } catch (e) {}
    playMedia(video, token);
  }

  function attachHlsJs(video, hlsSrc, token, Hls) {
    if (!Hls?.isSupported?.()) {
      attachMp4(video, token);
      return;
    }
    destroyHls(video);
    const hls = new Hls({
      enableWorker: true,
      maxBufferLength: 10,
      maxMaxBufferLength: 20,
      startLevel: 0,
      capLevelToPlayerSize: true,
    });
    hlsByVideo.set(video, hls);
    video.dataset.loaded = "true";

    hls.on(Hls.Events.MANIFEST_PARSED, () => playMedia(video, token));
    hls.on(Hls.Events.ERROR, (_event, data) => {
      if (!data?.fatal) return;
      if (token !== loadToken || activeVideo !== video) return;
      destroyHls(video);
      attachMp4(video, token);
    });

    hls.loadSource(hlsSrc);
    hls.attachMedia(video);
  }

  function playHoverVideo(video) {
    if (!video) return;

    if (activeVideo && activeVideo !== video) {
      unloadVideo(activeVideo);
    }

    const token = ++loadToken;
    activeVideo = video;

    if (video.dataset.playing === "true" && video.dataset.loaded === "true") {
      playMedia(video, token);
      return;
    }

    const hlsSrc = video.dataset.hlsSrc;
    if (hlsSrc) {
      if (canPlayNativeHls()) {
        attachNativeHls(video, hlsSrc, token);
      } else {
        loadHlsJs()
          .then((Hls) => {
            if (token !== loadToken || activeVideo !== video) return;
            attachHlsJs(video, hlsSrc, token, Hls);
          })
          .catch(() => {
            if (token !== loadToken || activeVideo !== video) return;
            attachMp4(video, token);
          });
      }
      return;
    }

    attachMp4(video, token);
  }

  function pauseHoverVideo(video) {
    loadToken += 1;
    unloadVideo(video);
  }

  document.addEventListener("mouseover", (event) => {
    const video = getCardHoverVideo(event.target);
    if (!video) return;
    const card = video.closest(".card");
    if (!isLeavingOrEnteringCard(card, event.relatedTarget)) return;
    playHoverVideo(video);
  });

  document.addEventListener("mouseout", (event) => {
    const video = getCardHoverVideo(event.target);
    if (!video) return;
    const card = video.closest(".card");
    if (!isLeavingOrEnteringCard(card, event.relatedTarget)) return;
    pauseHoverVideo(video);
  });
})();

// Custom video controls
document.addEventListener('DOMContentLoaded', () => {
  const BUTTON_SELECTOR = '.wt-hero-video__sound-toggle';
  const BUTTON_TOGGLE_CLASS = 'wt-hero-video__sound-toggle--unmuted';

  document.querySelectorAll(BUTTON_SELECTOR).forEach(button => {
    button.addEventListener('click', () => {
      const parent = button.parentElement;
      if (!parent) return;

      let video = null;

      video = Array.from(parent.children).find(
          el => el.tagName === 'VIDEO'
      );

      if (!video) {
        const heroVideoContainer = Array.from(parent.children).find(
            el => el.classList && el.classList.contains('hero--video-background')
        );

        if (heroVideoContainer) {
          video = heroVideoContainer.querySelector('video');
        }
      }

      if(!video){
          const grandparent = parent.closest('video-controls');
          console.log(grandparent);
          video = Array.from(grandparent.children).find(
            el => el.tagName === 'VIDEO'
        );
      }

      if (!video) return;

      video.muted = !video.muted;
      button.classList.toggle(BUTTON_TOGGLE_CLASS, !video.muted);
    });
  });
});
